import React, { useState } from "react";
import PropTypes from "prop-types";
import { Tooltip } from "@mui/material";

import './SwitchButton.css'
import { Popover } from "antd";

const SwitchButton = (props) => {
  const {
    initialState,
    onSwitch,
    leftLabel,
    rightLabel,
    tooltipText,
    showTooltip,
    classNames,
  } = props;

  const [switchTab, setSwitchTab] = useState(initialState || false);

  const handleSwitch = () => {
    const updatedState = !switchTab;
    setSwitchTab(updatedState);
    if (onSwitch) {
      onSwitch(updatedState);
    }
  };

  return (
    <div className={`switch-btn-block ${classNames}`}>
      <div className="switch-btn">
        <span className="switch-btn-label">{leftLabel}</span>
        <span className="switch-btn-label">{rightLabel}</span>
        <span
          className={`switch-btn-track ${switchTab ? "right-[3px]" : "right-[53%]"}`}
          onClick={handleSwitch}
        ></span>
      </div>
      {showTooltip && (
        <Popover content={tooltipText} placement="top">
          <img src="/images/fi_info.svg" alt="info" className="ml-[10px]" />
        </Popover>
      )}
    </div>
  );
};

SwitchButton.propTypes = {
  initialState: PropTypes.bool,
  onSwitch: PropTypes.func,
  leftLabel: PropTypes.string,
  rightLabel: PropTypes.string,
  tooltipText: PropTypes.string,
  classNames: PropTypes.string,
  showTooltip: PropTypes.bool,
};

export default SwitchButton;
